import type { NPCConfig } from '@/entities';
import v2Day1SharedNPCs from "@/config/NPCConfigs/v2/V2Day1SharedNPCs.ts";
// import {StoryManager} from "@/systems";

let filteredShared = v2Day1SharedNPCs.filter(obj=>obj.name !== "Sondakh" && obj.name !== "Holga" && obj.spriteImage !== "assets/sprite/gate_close.png")

console.log("FSHARE", filteredShared)

const config: NPCConfig[] = [
    //Bunga : lagi didepan rumah kalau didkeetin trigger auto next 'stage;, dia bilang ulang tahn
    //
  ...filteredShared,
  {
    x: 2415,
    y: 1875,
    // x: 2480,
    // y: 1860,
    name: '',
    color: 0x9932cc,
    scale : 0.2,
    repeatable : true,
    flipSprite : false,
    spriteImage: 'assets/sprite/nada.png',
    dialogTree: {
      startDialogId: 'gate_1',
      nodes: {
        gate_1: {
          id: 'toilet_1',
          speaker: 'Yan',
          text: 'Pintu ini terbuka?',
          characterImage: '/assets/character/v2/yanf.png',
          backgroundImage: '/assets/cutscene/gate.png',
          nextDialogId : "gate_2"
        },
        gate_2: {
          id: 'toilet_1',
          speaker: 'Yan',
          text: 'Apa ini?',
          characterImage: '/assets/character/v2/yanf.png',
          backgroundImage: '/assets/cutscene/gate.png',
          nextDialogId : "gate_3"
        },
        gate_3: {
          id: 'toilet_1',
          speaker: 'Yan',
          text: 'Ada kain berdarah yang tersangkut di pintu ini. Dari manakah kira-kira?',
          characterImage: '/assets/character/v2/yanf.png',
          backgroundImage: '/assets/cutscene/gate.png',
          nextDialogId : "gate_3",
          isEnd : true,
        },
      },
    },
  },
  {
    x: 3600,
    y: 1810,
    name: 'Holga',
    spriteImage: 'assets/sprite/sprite_holga.png', // Use NPC image
    dialogTree: {
      startDialogId: 'holga_1',
      triggerOnCollision: true,
      nodes: {
        holga_1: {
          id: 'holga_1',
          speaker: 'Holga',
          text: `Apakah kamu melihat anak saya?.`,
          characterImage: '/assets/character/v2/holga.png',
          backgroundImage: '/assets/backdrop/rumah.png',
          nextDialogId : "holga_2",
        },
        holga_2: {
          id: 'holga_2',
          speaker: 'Holga',
          text: `Dia gadis paling cantik di desa ini.`,
          characterImage: '/assets/character/v2/holga.png',
          backgroundImage: '/assets/backdrop/rumah.png',
          nextDialogId : "holga_3",
        },
        holga_3: {
          id: 'holga_3',
          speaker: 'Holga',
          text: `Saya pergi ke gereja sebentar, saat kembali ke rumah dia sudah tidak dirumah`,
          characterImage: '/assets/character/v2/holga.png',
          backgroundImage: '/assets/backdrop/rumah.png',
          nextDialogId : "sondakh_3",
          isEnd : true
        },
      },
    },
  },
  {
    x: 5780,
    y: 2280,
    name: '',
    color: 0x9932cc, // Dark orchid
    spriteImage: 'assets/sprite/sprite_sondakh_dead.png', // Use NPC image
    dialogTree: {
      startDialogId: 'bunga_part2_1',
      nodes: {
        bunga_part2_1: {
          id: 'bunga_part2_1',
          speaker: '',
          text: ``,
          backgroundImage: '/assets/cutscene/death_sondakh.jpg',
          nextDialogId : "bunga_day1_2",
          isEnd : true
        },
      },
    },
  },
  {
    x: 1810,
    y: 1520,
    name: 'Nenek',
    spriteImage: 'assets/sprite/sprite_nenek1.png', // Use NPC image
    dialogTree: {
      startDialogId: 'nenek1',
      nodes: {
        nenek1: {
          id: 'nenek1',
          speaker: 'Nenek',
          text: `Selamat siang Yan`,
          characterImage: '/assets/character/v2/nenek.png',
          backgroundImage: '/assets/backdrop/rumah.png',
          nextDialogId : "nenek2",
        },
        nenek2: {
          id: 'nenek2',
          speaker: 'Nenek',
          text: ``,
          characterImage: '/assets/character/v2/nenek.png',
          backgroundImage: '/assets/backdrop/rumah.png',
          choices: [
            {
              text: 'Selamat siang nek, apa kabar?',
              nextDialogId: 'nenek3a',
            },
            {
              text: 'Selamat siang nek, sedang apa?',
              nextDialogId: 'nenek3b',
            },
          ],
        },
        nenek3a: {
          id: 'nenek3a',
          speaker: 'Nenek',
          text: `Kabar nenek sangat baik. Hari ini nenek sangat segar`,
          characterImage: '/assets/character/v2/nenek.png',
          backgroundImage: '/assets/backdrop/rumah.png',
          nextDialogId : "nenek2",
          isEnd : true
        },
        nenek3b: {
          id: 'nenek3b',
          speaker: 'Nenek',
          text: `Nenek sedang berjemur, cuacanya hari ini sangat baik ya.`,
          characterImage: '/assets/character/v2/nenek.png',
          backgroundImage: '/assets/backdrop/rumah.png',
          nextDialogId : "nenek2",
          isEnd : true
        },
      },
    },
  },
  {
    x: 5850,
    y: 1550,
    name: 'Elsa',
    color: 0x9932cc, // Dark orchid
    spriteImage: 'assets/sprite/sprite_elsa.png', // Use NPC image
    dialogTree: {
      startDialogId: 'elsa_1',
      triggerOnCollision: true,
      nodes: {
        elsa_1: {
          id: 'elsa_1',
          speaker: 'Elsa',
          text: `Yan! Kita butuh bantuan!`,
          characterImage: '/assets/character/v2/elsa.png',
          backgroundImage: '/assets/backdrop/danau.png',
          nextDialogId : "elsa_2",
        },
        elsa_2: {
          id: 'elsa_2',
          speaker: 'Elsa',
          text: ``,
          characterImage: '/assets/character/v2/elsa.png',
          backgroundImage: '/assets/backdrop/danau.png',
          choices: [
            {
              text: 'Jangan panik, jelaskan apa yang terjadi.',
              nextDialogId: 'elsa_3',
            },
            {
              text: 'Ada apa, kenapa kamu terburu-buru Elsa?',
              nextDialogId: 'elsa_3',
            },
          ],
        },
        elsa_3: {
          id: 'elsa_1',
          speaker: 'Elsa',
          text: `Aku dan Diana menemukan mayat!`,
          characterImage: '/assets/character/v2/elsa.png',
          backgroundImage: '/assets/backdrop/danau.png',
          nextDialogId : "elsa_4",
        },
        elsa_4: {
          id: 'elsa_4',
          speaker: 'Elsa',
          text: `Aku harus cepat kembali ke orang desa dan meminta bantuan!`,
          characterImage: '/assets/character/v2/elsa.png',
          backgroundImage: '/assets/backdrop/danau.png',
          nextDialogId : "elsa_4",
          isEnd : true
        },
      },

    },

  },
  {
    x: 5820,
    y: 2250,
    name: 'Diana',
    color: 0x9932cc, // Dark orchid
    spriteImage: 'assets/sprite/sprite_diana.png', // Use NPC image
    dialogTree: {
      startDialogId: 'diana_1',
      nodes: {
        diana_1: {
          id: 'diana_1',
          speaker: 'Diana',
          text: `Kak Yan! Apa yang harus kita lakukan!`,
          backgroundImage: '/assets/backdrop/danau.png',
          characterImage: '/assets/character/v2/diana.png',
          nextDialogId : "diana_2",
        },
        diana_2: {
          id: 'diana_2',
          speaker: 'Diana',
          text: ``,
          backgroundImage: '/assets/backdrop/danau.png',
          characterImage: '/assets/character/v2/diana.png',
          choices: [
            {
              text: 'Tenang dulu Diana, bisakah kamu menjelaskan apa yang terjadi?',
              nextDialogId: 'diana_3',
            },
            {
              text: 'Sebaiknya kita menunggu Elsa kembali dengan orang-orang desa.',
              nextDialogId: 'diana_end_1',
            },
          ],
        },
        diana_end_1: {
          id: 'diana_end_1',
          speaker: 'Diana',
          text: `Sepertinya, Elsa telah kembali dengan orang-orang desa.`,
          backgroundImage: '/assets/backdrop/danau.png',
          characterImage: '/assets/character/v2/diana.png',
          //Ini harusnya day ender?
          storyAction: { type: 'nextDay', value: 0 },
          isEnd : true
        },
        diana_3: {
          id: 'diana_3',
          speaker: 'Diana',
          text: `Aku sedang berjalan kembali ke desa bersama Elsa, kami ingin menjemput kak Yan.`,
          backgroundImage: '/assets/backdrop/danau.png',
          characterImage: '/assets/character/v2/diana.png',
          nextDialogId: 'diana_4',
        },
        diana_4: {
          id: 'diana_4',
          speaker: 'Diana',
          text: `Lalu kita melihat ada sesuatu di balik semak-semak hanyut.`,
          backgroundImage: '/assets/backdrop/danau.png',
          characterImage: '/assets/character/v2/diana.png',
          nextDialogId: 'diana_5',
        },
        diana_5: {
          id: 'diana_5',
          speaker: 'Diana',
          text: `....`,
          backgroundImage: '/assets/backdrop/danau.png',
          characterImage: '/assets/character/v2/diana.png',
          nextDialogId: 'diana_end_1',
        },
        //suruh tenang dulu. jelasin
      },
    },
  },

  {
    x: 4700,
    y: 2500,
    name: 'Bunga',
    color: 0x9932cc, // Dark orchid
    spriteImage: 'assets/sprite/sprite_bunga.png', // Use NPC image
    dialogTree: {
      startDialogId: 'bunga_1',
      nodes: {
        bunga_1: {
          id: 'merchant_greeting',
          speaker: 'Bunga',
          text: `Halo Yan, akhirnya kamu sampai juga.`,
          backgroundImage: '/assets/backdrop/danau.png',
          characterImage: '/assets/character/v2/bunga.png',
          nextDialogId: 'bunga_2',
        },
        bunga_2: {
          id: 'merchant_greeting',
          speaker: 'Bunga',
          text: `Dimana yang lain?`,
          backgroundImage: '/assets/backdrop/danau.png',
          characterImage: '/assets/character/v2/bunga.png',
          nextDialogId: 'bunga6',
        },
        bunga6: {
          id: 'merchant_greeting',
          speaker: 'Bunga',
          text: ``,
          backgroundImage: '/assets/backdrop/danau.png',
          characterImage: '/assets/character/v2/bunga.png',
          nextDialogId: 'bunga7',
          choices: [
            {
              text: 'Sepertinya kita harus segera berberes-beres, ada kejadian di sisi lain danau',
              nextDialogId: 'bunga_end_1',
              storyAction: { type: 'nextDay', value: 0 },
              //ini gak next day tapi sebaiknya balik ke diana?
            },
            {
              text: 'Aku tidak melihat mereka. Mungkin lebih baik kita mulai berdua dulu.',
              nextDialogId: 'nenek3b',
              storyAction: { type: 'addCustomValue', value: {key : "bunga_affinity", value : 1} },
              //TODO Apakah ada adengan dulu sebelum itu?
            },
          ],
        },
        bunga_end_1: {
          id: 'merchant_greeting',
          speaker: 'Bunga',
          text: `Baiklah, ayo kita bergegas`,
          backgroundImage: '/assets/backdrop/danau.png',
          characterImage: '/assets/character/v2/bunga.png',
          nextDialogId: 'bunga6',
          storyAction: { type: 'nextDay', value: 0 },
          isEnd : true
        },


      },
    },
  },

];

export default config;
